<template>
  <v-dialog
    :value="value"
    max-width="1200"
    persistent
    scrollable
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title>
        EDI申請選択
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-4">
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="emission_requests"
          item-key="id"
          :items-per-page="-1"
          disable-pagination
          disable-sort
          hide-default-footer
          dense
          single-select
          :item-class="rowClass"
          @click:row="onRowClick"
          @dblclick:row="rowDoubleClickEvent"
        >
          <template v-slot:[`item.jwnet_pricing_type_name`]="{ item }">
            <div>{{ item.jwnet_pricing_type_name | jwnet_pricing_type_label }}</div>
          </template>
          <template v-slot:[`item.tenant_info`]="{ item }">
            <div>{{ item.tenant_code }}</div>
            <div class="line-clamp one-clamp">{{ item.tenant_name }}</div>
          </template>
          <template v-slot:[`item.jwnet_info`]="{ item }">
            <div class="line-clamp one-clamp">{{ item.jwnet_name }}</div>
            <div class="line-clamp one-clamp">{{ item.emission_name }}</div>
          </template>
          <template v-slot:[`item.address_info`]="{ item }">
            <div class="line-clamp one-clamp">{{ item.address }}</div>
            <div>{{ item.code }}</div>
          </template>
          <template v-slot:[`item.staff_names`]="{ item }">
            <div class="line-clamp one-clamp">{{ item.person_in_charge }}</div>
          </template>
        </v-data-table>
        <!-- ページャ -->
        <v-row v-if="totalPages > 1" dense>
          <v-col>
            <v-pagination
              v-model="page"
              :length="totalPages"
              :total-visible="totalVisible"
              circle
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
              @input="changePage"
            />
          </v-col>
        </v-row>
        <!-- /ページャ -->
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn 
          @click="closeDialog"
          >
          閉じる
        </v-btn>
        <v-btn
          color="primary"
          :disabled="!selectedEmission"
          @click="selectEmission(selectedEmission)"
        >
          選択
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'EmissionSelectDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    emissionRequestIds: {
      type: Array,
      default: () => []
    },
    currentItem: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      page: 1,
      totalPages: 1,
      totalVisible: 7,
      totalCount: 0,
      loading: false,
      emission_requests: [],
      headers: [
        { value: 'jwnet_pricing_type_name', text: '料金区分', width: '10%' },
        { value: 'tenant_info', text: 'テナントコード\r\nテナント名', width: '20%' },
        { value: 'jwnet_info', text: 'JWNET登録名\r\n排出事業者名', width: '30%' },
        { value: 'address_info', text: '住所\r\n事業者コード', width: '20%' },
        { value: 'staff_names', text: '担当者', width: '20%' },
      ],
      selected: [],
      selectedEmission: null,
    }
  },
    mounted() {
      this.selectedEmission = null;
    },
  watch: {
    value(newVal) {
      if (newVal) {
        this.page = 1;
        this.fetchData(this.page)
      }
    },
    selected(newVal) {
      this.selectedEmission = newVal && newVal.length > 0 ? newVal[0] : null
    }
  },
  methods: {
    ...mapActions('AdminEdiRequestEmissionSelect', {
      fetchEdiRequests: 'index',
    }),
    /**
     * 行のクラスを返す
     * @param item
     */
    rowClass(item) {
      return this.selectedEmission && this.selectedEmission.id === item.id ? 'selected-row' : ''
    },
    /**
     * 行選択イベント
     * @param item
     */
    onRowClick(item) {
      // single-selectの場合、クリックで選択/解除をトグルする
      if (this.selected.length > 0 && this.selected[0].id === item.id) {
        this.selected = []
      } else {
        this.selected = [item]
      }
    },
    /**
     * 行反映ダブルクリックイベント
     * @param $event { MouseEvent }
     * @param row { Object } 行
     */
    rowDoubleClickEvent($event, row) {
      this.$emit("selected", {
        item: this.currentItem,
        emission_request: row.item
      })
      this.closeDialog()
    },
    fetchData(page = 1) {
      const params = {
        select_emission: true,
        emission_request_ids: this.emissionRequestIds,
        page: page,
      }
      this.fetchEdiRequests(params).then((content) => {
        this.emission_requests = content.edi_requests || []
        // ページ情報の更新
        if (content.pagination) {
          this.totalPages = content.pagination.total_pages || 1
          this.totalCount = content.pagination.total_count || 0
        }
      })
    },
    changePage() {
      this.fetchData(this.page)
    },
    selectEmission(emission_request) {
      if (!emission_request) return;
      this.$emit('selected', {
        item: this.currentItem,
        emission_request: emission_request
      })
      this.closeDialog()
    },
    closeDialog() {
      this.$emit('input', false)
      this.emission_requests = []
      this.page = 1
      this.totalPages = 1
      this.totalCount = 0
      this.selected = []
      this.selectedEmission = null
    }
  },
}
</script>

<style scoped lang="scss">
  .selected-row {
    background-color: #e3f2fd !important;
  }
  
  ::v-deep tbody tr {
    cursor: pointer;
  }
</style>
